export default __webpack_public_path__ + "static/media/bg-sea.5dc38017.jpg";